import { useMutation } from '@apollo/client';
import { createError } from '@common/neo.tax';

import {
  TaxDocument,
  RecordDownloadDocumentMutation,
  RecordDownloadDocumentMutationVariables,
  RECORD_DOWNLOAD_DOCUMENT,
  downloadFileFromRemoteUrl,
} from '@neo.tax/shared';

export const useDownloadTaxDocument = (): {
  downloadTaxDocument: (taxDocument: TaxDocument) => Promise<void>;
} => {
  const [recordDownloadRdTaxCreditForms] = useMutation<
    RecordDownloadDocumentMutation,
    RecordDownloadDocumentMutationVariables
  >(RECORD_DOWNLOAD_DOCUMENT);

  const downloadTaxDocument = async (taxDocument: TaxDocument): Promise<void> => {
    const { documentType, fileName, taxAuthority, url } = taxDocument;
    if (!documentType || !fileName || !taxAuthority || !url) {
      throw createError('DownloadTaxDocumentError', 'Error downloading tax document');
    }
    await Promise.all([
      downloadFileFromRemoteUrl({ fileName, url }),
      recordDownloadRdTaxCreditForms({
        variables: {
          fiscalYearId: taxDocument.fiscalYearId,
          documentInput: {
            documentType,
            taxAuthority,
          },
        },
      }),
    ]);
  };

  return {
    downloadTaxDocument,
  };
};
